import { config as smu01 } from "./Smu01/config";
import { config as smu02 } from "./Smu02/config";
import { config as smu03 } from "./Smu03/config";
import { config as smu04 } from "./Smu04/config";
import { config as smu05 } from "./Smu05/config";
import { config as smu06 } from "./Smu06/config";
import { config as smu07 } from "./Smu07/config";
import { config as smu08 } from "./Smu08/config";
import { config as sev01 } from "./Sev01/config";
import { config as sev02 } from "./Sev02/config";
import { config as sev03 } from "./Sev03/config";

export const TemplatesManager = {
    multimediaTemplates: [smu01, smu02, smu03, smu04, smu05, smu06, smu07, smu08],
    questionTemplates: [sev01, sev02, sev03],
};

export * from "./Sev01"
export * from "./Sev02"
export * from "./Sev03"
export * from "./Smu01"
export * from "./Smu02"
export * from "./Smu03"
export * from "./Smu04"
export * from "./Smu05"
export * from "./Smu06"
export * from "./Smu07"
export * from "./Smu08"